<head>
    <title>Reset-code-interface Wegestu</title>
    <meta name="description" content="Reset-code-interface Wegestu">
</head>
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="d-flex flex-column flex-root" id="kt_app_root">
    <div class="code-verification">
        <div class="d-flex flex-column flex-center flex-column-fluid">
            <!--begin::Content-->
            <div class="d-flex flex-column flex-center p-10">
                <!--begin::Wrapper-->
                <div class="card-warp w-md-650px py-5 content-login">
                    <div class="content py-15 py-lg-20">
                        <!--begin::Logo-->
                        <div class="mb-15 text-center">
                            <a class="">
                                <img alt="Logo" src="/assets/media/logos/wegestu.png" class="h-150px logo-login" />
                            </a>
                        </div>
                        <!--end::Logo-->

                        <div class="mb-10">
                            <!--begin::Label-->
                            <div class="text-center code-title fs-6 mb-10 ms-1">
                                Entrer votre code
                            </div>
                            <!--end::Label-->
                            <!--begin::Input group-->
                            <div class="d-flex flex-wrap flex-stack" [formGroup]="generateCodeForm"
                                (keyup.enter)="codeVerification()">
                                <input type="text" name="code_1" formControlName="number1" #input1
                                    (keyup)="(input1.value.length == 1) ? input2.focus() : ''"
                                    data-inputmask="'mask': '9', 'placeholder': ''" maxlength="1"
                                    class="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-1 my-2"
                                    value="" />
                                <input type="text" name="code_2" formControlName="number2" #input2
                                    (keyup)="(input2.value.length == 1) ? input3.focus() : ''"
                                    data-inputmask="'mask': '9', 'placeholder': ''" maxlength="1"
                                    class="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-1 my-2"
                                    value="" />
                                <input type="text" name="code_3" formControlName="number3" #input3
                                    (keyup)="(input3.value.length == 1) ? input4.focus() : ''"
                                    data-inputmask="'mask': '9', 'placeholder': ''" maxlength="1"
                                    class="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-1 my-2"
                                    value="" />
                                <input type="text" name="code_4" formControlName="number4" #input4
                                    data-inputmask="'mask': '9', 'placeholder': ''" maxlength="1"
                                    class="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-1 my-2"
                                    value="" />
                            </div>
                            <!--begin::Input group-->
                        </div>
                        <!--begin::Submit-->
                        <div class="d-flex flex-center mb-3">
                            <button [disabled]="!this.generateCodeForm.valid" (click)="codeVerification()" type="button"
                                id="kt_sing_in_two_factor_submit" class="btn btn-lg w-100 pt-5 pb-5 btnconfirm">
                                <span class="indicator-label">Confirmer</span>
                                <span class="indicator-progress">Please wait...
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                            </button>
                        </div>
                        <div class="text-center">
                            <small class="info-message">
                            Si vous ne recevez pas le code de vérification, pensez à vérifier vos spams ou courriers indésirables.
                            </small>
                        </div>
                        <!--end::Submit=-->
                        <div class="redirect-login mt-5 d-flex justify-content-center">
                            <label class="form-check-label" for="flexCheckDefault">
                                Vous n'avez pas reçu le code?
                            </label>
                            <a (click)="resendCodeVerification()" class="link-primary btn_renvoyer" style="cursor: pointer;">&nbsp; Renvoyer </a>

                        </div>
                    </div>
                </div>
                <!--end::Wrapper-->
            </div>
            <!--end::Content-->
        </div>
    </div>
</div>
<script src="./assets/js/custom/authentication/sign-in/two-factor.js"></script>